
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryPack0 as ObiBatteryPack0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-pack-0.js';
 
 
 

 
 export const ObiBatteryPack0 = createComponent({
   react: React,
   tagName: 'obi-battery-pack-0',
   elementClass: ObiBatteryPack0Element,
   events: {
     
   }
  });
 
 